import { AppContext } from "@/App.context";
import config from "@/config";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";

/**
 * @typedef GetAllStatistics
 * @property {string} filter
 * @property {GetDataStatistics} data
 */

/**
 * @typedef GetDataStatistics
 * @property {string} id
 */

/**
 * @typedef GetIdleFilters
 * @property {string[]} accounts
 */

/**
 * @typedef GetAllStatisticsRes
 * @property {GetAllStatistics[]} statistics
 * @property {GetIdleFilters} filters
 */

/**
/**
 * @typedef GetAccountStatisticsReq
 * @property {'aws' | 'gcp' | 'azure'} service
 * @property {'account' | 'region' | 'rg' } selectedTittle
 */

export const getReportingFilter = (token) => {
  /**
   * @param {GetAccountStatisticsReq} req
   * @param {AbortSignal=} signal
   * @returns {Promise<GetAllStatistics>}
   */
  return async ({ service, selectedTittle, filters }, signal) => {
    const owners = await fetch(
      `${config.reportApiHost}/v1/${service}/reporting/filter?type=${selectedTittle}`,
      {
        method: "GET",
        signal,
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );
    if (!owners.ok) {
      throw new Error((await owners.json()).message);
    }
    return await owners.json();
  };
};

/**

 * @param {GetAccountStatisticsReq} req
 * @param {any[]=} deps
 */
export const useReportignFilter = (req, deps = []) => {
  const appContext = useContext(AppContext);
  const query = useQuery({
    queryKey: ["getReportingFilter", req, ...deps],
    queryFn: ({ signal }) =>
      getReportingFilter(appContext.idToken)(req, signal),
    enabled: req.selectedTittle != null,
  });
  return query;
};
